import React from 'react';

const CurvedText = ({ text }) => {
  return (
    <svg viewBox="0 0 500 500">
      <path
        id="curve1"
        d="M73.2,148.6c4-6.1,65.5-96.8,178.6-95.6c111.3,1.2,170.8,90.3,175.1,97"
        fill="transparent"
      />
      <text width="500" fill="#ffffff">
        <textPath xlinkHref="#curve1">{text}</textPath>
      </text>
    </svg>
  );
};

export default CurvedText;
